import React from "react"
import Button from "./Button"
import { Container, Row, Col } from "react-bootstrap"
import "./../styles/page-success.scss"
import NewsCards from "./Cards/NewsList"

export default ({
  news,
  successMessage,
  successCTA,
  successThankyou,
  successLabel,
  successLink,
}) => {
  return (
    <Container className="success hide">
      <Col className="success-heading px-0">
        <h1>Success!</h1>
        <p className="subtitle">{successThankyou}</p>
        <p>{successMessage}</p>
        <Row>
          <Col md={6}>{successCTA}</Col>
          <Col className={"text-right"} md={6}>
            <Button
              icon={`arrow-right`}
              className={`btn btn-bg-red`}
              label={successLabel}
              target={"_blank"}
              rel={"noopener norefferer"}
              href={successLink}
            />
          </Col>
        </Row>
      </Col>
      <Container className="pb-5" fluid>
        {news && <NewsCards items={news} />}
      </Container>
    </Container>
  )
}
